// extracted by mini-css-extract-plugin
module.exports = {"container":"MainHeaderSearchBar_container_12HBL","search":"MainHeaderSearchBar_search_1NUor"};